// Components==============
import { faChevronDown, faLock } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AnimatePresence, motion } from 'framer-motion';
import { useTranslate } from 'hooks/useTranslate';
import React, { useState } from 'react';
import { framerCollapse } from 'utilities/FramerAnimations';
import './TrainingCollapseCard.module.scss';
// =========================

type Props = {
  left: React.ReactNode;
  children: React.ReactNode;
  editMode?: boolean;
  locked?: boolean;
} & (
  | {
      sessionIndex?: never;
      background?: never;
      lessonIndex: number;
    }
  | {
      sessionIndex: number;
      background?: string;
      lessonIndex?: never;
    }
);

export default function TrainingCollapseCard({
  left,
  children,
  lessonIndex,
  background,
  sessionIndex,
  editMode,
  locked,
}: Props) {
  const translate = useTranslate();
  const [collapsed, setCollapsed] = useState(false);

  const lessonTitle = `${translate('course.terms.lesson')} ${lessonIndex}`;
  const sessionTitle = `${translate('course.terms.session')} ${sessionIndex}`;

  return (
    <div id={lessonTitle}>
      {!!lessonIndex && (
        <p styleName="title">
          {locked && <FontAwesomeIcon icon={faLock} />} {lessonTitle}
        </p>
      )}
      {!!sessionIndex && (
        <h3 styleName="title">
          {locked && <FontAwesomeIcon icon={faLock} />} {sessionTitle}
        </h3>
      )}
      <div
        styleName={`wrapper ${sessionIndex ? 'session-wrapper' : ''} ${
          editMode ? 'edit-mode' : ''
        } ${
          (!editMode && sessionIndex) || background ? 'with-background' : ''
        }`}
        style={{
          backgroundImage: `url(${background})` || '',
          boxShadow: background
            ? 'rgba(0, 0, 0, 0.55) 0px 0px 0px 1000px inset'
            : '',
        }}
      >
        <div
          styleName="top"
          style={{
            marginBottom: collapsed ? 0 : '1em',
          }}
        >
          {left}
          <motion.button
            initial={{ rotate: 180 }}
            animate={{ rotate: collapsed ? 0 : 180 }}
            type="button"
            onClick={() => setCollapsed((prev) => !prev)}
            styleName="arrow"
          >
            <FontAwesomeIcon icon={faChevronDown} />
          </motion.button>
        </div>
        <motion.div
          animate={collapsed ? 'initial' : 'animate'}
          initial="animate"
          // @ts-ignore
          variants={framerCollapse}
        >
          <AnimatePresence>{!collapsed && children}</AnimatePresence>
        </motion.div>
      </div>
    </div>
  );
}
